// extracted by css-extract-rspack-plugin
export default {"root":"src-pages-ErrorPage-module__root-t3q4pL","debugInfo":"src-pages-ErrorPage-module__debugInfo-XaARUe","stack":"src-pages-ErrorPage-module__stack-KsJ69s"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-pages-ErrorPage-module__root-t3q4pL\",\"debugInfo\":\"src-pages-ErrorPage-module__debugInfo-XaARUe\",\"stack\":\"src-pages-ErrorPage-module__stack-KsJ69s\"}";
        // 1788963435624
        var cssReload = require("../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  